// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__YVZ_f","container":"styles_container__Rrx3I","title":"styles_title__IZq5b","wrapper":"styles_wrapper__3npIL","answer":"styles_answer__1dauq"};